import { createContext, useContext } from 'react';

const LangContext = createContext();

export const useLangCtx = () => useContext(LangContext);

export default LangContext;
